import React, { useState, useEffect } from "react"
import Category from "./Category.js"

// Category titles for each certification
const categoryTitles = {
  admin1: [
    "Configuration and Setup",
    "Object Manager and Lightning App Builder",
    "Sales and Marketing Applications",
    "Service and Support Applications",
    "Productivity and Collaboration",
    "Data and Analytics Management",
    "Automation",
    "Agentforce AI",
  ],
  admin2: [
    "Security and Access",
    "Objects and Applications",
    "Auditing and Monitoring",
    "Cloud Applications",
    "Data and Analytics Management",
    "Environment Management and Deployment",
    "Process Automation",
  ],
  "app-builder": [
    "Salesforce Fundamentals",
    "Data Modeling and Management",
    "Business Logic and Process Automation",
    "User Interface",
    "App Deployment",
  ],
  "business-analyst": [
    "Customer Discovery",
    "Collaboration with Stakeholders",
    "Business Process Mapping",
    "Requirements",
    "User Stories",
    "Development Support and User Acceptance",
  ],
  developer1: [
    "Developer Fundamentals",
    "Process Automation and Logic",
    "User Interface",
    "Testing, Debugging, and Deployment",
  ],
}

// Build values array and index map based on number of categories
function buildBoardConfig(numCategories) {
  const points = ["200", "400", "600", "800", "1000"]
  const values = []
  for (const pt of points) {
    for (let c = 0; c < numCategories; c++) {
      values.push(pt)
    }
  }

  // Map tile position to clue index in the data array
  // Data is sorted by category_id then points, so:
  //   index = (categoryIndex * 5) + pointIndex
  // Tiles are laid out: row = pointIndex, col = categoryIndex
  //   tileId = (pointIndex * numCategories) + categoryIndex
  const indexMap = {}
  for (let cat = 0; cat < numCategories; cat++) {
    for (let pt = 0; pt < 5; pt++) {
      const tileId = pt * numCategories + cat
      const clueIndex = cat * 5 + pt
      indexMap[tileId] = clueIndex
    }
  }

  return { values, indexMap }
}

const Categories = ({ setScore, setCluesAnswered, category, setCategory, activeCert }) => {
  const [selectedAnswer, setSelectedAnswer] = useState(false)
  const [incorrectAnswer, setIncorrectAnswer] = useState(false)
  const [categoryId, setCategoryId] = useState(0)
  const [selectedClueIndex, setSelectedClueIndex] = useState(0)
  const [idx, setIdx] = useState(null)
  const [selectedOption, setSelectedOption] = useState([])

  const titles = categoryTitles[activeCert] || categoryTitles.admin1
  const numCategories = titles.length
  const { values, indexMap } = buildBoardConfig(numCategories)

  const emptyBoard = new Array(values.length).fill({ answered: false, id: null })

  const [hasBeenAnsweredByCert, setHasBeenAnsweredByCert] = useState({
    admin1: new Array(40).fill({ answered: false, id: null }),
    admin2: new Array(35).fill({ answered: false, id: null }),
    "app-builder": new Array(25).fill({ answered: false, id: null }),
    "business-analyst": new Array(30).fill({ answered: false, id: null }),
    developer1: new Array(20).fill({ answered: false, id: null }),
  })

  const hasBeenAnswered = hasBeenAnsweredByCert[activeCert] || emptyBoard

  const setHasBeenAnswered = (valueOrUpdater) => {
    setHasBeenAnsweredByCert((prev) => ({
      ...prev,
      [activeCert]:
        typeof valueOrUpdater === "function"
          ? valueOrUpdater(prev[activeCert] || emptyBoard)
          : valueOrUpdater,
    }))
  }

  // Reset modal state when certification changes
  useEffect(() => {
    setSelectedAnswer(false)
    setIncorrectAnswer(false)
    setSelectedOption([])
  }, [activeCert])

  const getClues = (id) => {
    setSelectedClueIndex(indexMap[id] || 0)
  }

  const openCategoryModal = (categoryId) => {
    const id = Number(categoryId.target.id)

    setIdx(id)
    setCategory((prev) => !prev)
    setSelectedAnswer(false)
    setIncorrectAnswer(false)
    setSelectedOption([])
    getClues(id)

    // Compute category ID from tile position (1-based)
    setCategoryId((id % numCategories) + 1)
  }

  return (
    <>
      {titles.map((title, index) => (
        <div key={index} className="categoriesTitle">
          {title}
        </div>
      ))}
      {values.map((value, i) =>
        hasBeenAnswered[i].answered ? (
          <div key={i} id={i} className="categories"></div>
        ) : (
          <div
            key={i}
            id={i}
            className="categories"
            onClick={openCategoryModal}
          >
            {value}
          </div>
        ),
      )}

      <Category
        openCategoryModal={openCategoryModal}
        category={category}
        selectedAnswer={selectedAnswer}
        setSelectedAnswer={setSelectedAnswer}
        incorrectAnswer={incorrectAnswer}
        setIncorrectAnswer={setIncorrectAnswer}
        setHasBeenAnswered={setHasBeenAnswered}
        categoryId={categoryId}
        setScore={setScore}
        selectedClueIndex={selectedClueIndex}
        idx={idx}
        setCluesAnswered={setCluesAnswered}
        selectedOption={selectedOption}
        setSelectedOption={setSelectedOption}
        setSelectedClueIndex={setSelectedClueIndex}
        activeCert={activeCert}
      />
    </>
  )
}
export default Categories
